import Glenview81 from '../../../Media/Cibubur/Glenview/Tipe 8.webp'
import Glenview82 from '../../../Media/Cibubur/Glenview/gv 8.webp'



const Glenview8images =[
Glenview81,Glenview82,
]

export default Glenview8images;